// import * as MuiColors from "@mui/material/colors";

// const colors = Object.values(MuiColors).filter(
//   (color) =>
//     typeof color === "object" &&
//     // color !== MuiColors.amber &&
//     color !== MuiColors.common,
//   // color !== MuiColors.grey &&
//   // color !== MuiColors.lightBlue &&
//   // color !== MuiColors.lightGreen &&
//   // color !== MuiColors.orange &&
//   // color !== MuiColors.purple,
// );

// export const functionalColors: string[] = [
//   ...colors.flatMap((color) => color["300" as keyof typeof color]),
//   ...colors.flatMap((color) => color["600" as keyof typeof color]),
// ].filter(Boolean);

// grabbed from http://vrl.cs.brown.edu/color
export const functionalColors: string[] = [
  "#40655e",
  "#f87197",
  "#0ca82e",
  "#f35ff9",
  "#92a654",
  "#9433a1",
  "#b77529",
  "#125cb9",
  "#db3c23",
  "#35afa6",
  "#ad2a58",
  "#24a5f7",
  "#ff0087",
  "#3f6902",
  "#7c1cee",
  "#b0989e",
  "#3058fc",
  "#874e57",
  "#c186e6",
];
